import { c as _c } from "react/compiler-runtime";
import { Dropdown, useToast } from '@onefootprint/ui';
import { useClipboardGraph } from '../hooks/use-clipboard-graph';
import { useBuilder } from '../store/provider';
import { bundleToGraph } from '../store/wire';
type EmployeeActionsProps = {
  onModelConfig: () => void;
};

// Employee-only actions in the agent name dropdown: copy/replace the whole graph as JSON (for
// debugging or cloning an agent between environments) and model configuration. Rendered as a
// group, gated on isFirmEmployee by the parent. The model config dialog itself lives in the parent,
// outside the dropdown, so it survives the dropdown closing. Strings are hardcoded (internal-only).
const EmployeeActions = t0 => {
  const $ = _c(21);
  const {
    onModelConfig
  } = t0;
  const {
    toast
  } = useToast();
  const {
    state,
    mutateOp,
    canEdit
  } = useBuilder();
  const {
    getGraphToPaste,
    displayPasteAction
  } = useClipboardGraph();
  let t1;
  if ($[0] !== state.bundle || $[1] !== toast) {
    t1 = () => {
      const graph = bundleToGraph(state.bundle);
      navigator.clipboard.writeText(JSON.stringify(graph, null, 2));
      toast({
        title: "Copied!",
        description: "The agent graph has been copied to your clipboard."
      });
    };
    $[0] = state.bundle;
    $[1] = toast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCopyGraph = t1;
  let t2;
  if ($[3] !== getGraphToPaste || $[4] !== mutateOp || $[5] !== toast) {
    t2 = async () => {
      const graph_0 = await getGraphToPaste();
      if (!graph_0) {
        toast({
          title: "Nothing to paste",
          description: "Your clipboard does not contain a valid agent graph.",
          variant: "error"
        });
        return;
      }
      mutateOp({
        kind: "replace_graph",
        data: graph_0
      });
      toast({
        title: "Success!",
        description: "The graph has been replaced with the contents of your clipboard."
      });
    };
    $[3] = getGraphToPaste;
    $[4] = mutateOp;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleReplaceGraph = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dropdown.GroupTitle>Employee-only actions</Dropdown.GroupTitle>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleCopyGraph) {
    t4 = <Dropdown.Item onSelect={handleCopyGraph}>Copy graph</Dropdown.Item>;
    $[8] = handleCopyGraph;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = !canEdit || !displayPasteAction;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      height: "auto"
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="flex flex-col gap-0.5 py-0.5"><span>Replace graph (from clipboard)</span><span className="text-caption-3 text-tertiary">Replaces plan, norms, skills, and tools.</span></span>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleReplaceGraph || $[13] !== t5) {
    t8 = <Dropdown.Item disabled={t5} onSelect={handleReplaceGraph} style={t6}>{t7}</Dropdown.Item>;
    $[12] = handleReplaceGraph;
    $[13] = t5;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== onModelConfig) {
    t9 = <Dropdown.Item onSelect={onModelConfig}>Model configuration</Dropdown.Item>;
    $[15] = onModelConfig;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t8 || $[19] !== t9) {
    t10 = <Dropdown.Group>{t3}{t4}{t8}{t9}</Dropdown.Group>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default EmployeeActions;